export enum FetchStatus {
  idle = 'idle',
  pending = 'pending',
  fulfilled = 'fulfilled',
  failed = 'failed',
}
